import axios from 'axios';

import config from '@config';

export const getServerBaseUrl = () => {
  const currentDomain = window.location.origin;
  const serverPort = config.SERVER_PORT ?? '5000';
  const serverBaseURL = `${currentDomain.replace(
    /:\d+/,
    `${config.IS_IN_PRODUCTION === true ? '' : `:${serverPort}`}`,
  )}`;
  return serverBaseURL;
};

export const getServerApiClient = () => {
  const serverBaseURL = getServerBaseUrl();

  return axios.create({
    baseURL: serverBaseURL,
    withCredentials: true,
  });
};
